import { LocalDate } from '@js-joda/core';

import { PregnancyCompletionType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { dateFormatter, Translate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

type GynecologicalInterviewPregnancyCompletionInterviewProps = {
   readonly completionType: PregnancyCompletionType;
   readonly completionDate: LocalDate | undefined;
};

export const GynecologicalInterviewPregnancyCompletionInterview = (
   props: GynecologicalInterviewPregnancyCompletionInterviewProps
): JSX.Element => {
   return (
      <>
         <TextView testId={'interviewType'} label={gynecologicalInterviewTranslationKeys.type}>
            <Translate>{gynecologicalInterviewTranslationKeys.interviewType[props.completionType]}</Translate>
         </TextView>
         <TextView
            testId={'pregnancyCompletionDate'}
            label={gynecologicalInterviewTranslationKeys.pregnancyCompletionDate}
         >
            {props.completionDate ? dateFormatter(props.completionDate) : '-'}
         </TextView>
      </>
   );
};
